import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import HistoryView from "@/views/HistoryView.vue";
import MainLayout from "@/layouts/MainLayout.vue";
import AppointmentView from "@/views/AppointmentView.vue";
import UnavailableView from "@/views/UnavailableView.vue";

const routes = [
  {
    path: "/booking",
    component: MainLayout,
    children: [
      {
        path: "/:id",
        name: "home",
        component: HomeView,
      },
      {
        path: "/booking/history",
        name: "history",
        component: HistoryView,
        meta: { title: "Lịch sử đặt lịch", customHeader: true },
      },
      {
        path: "/booking/appointment/:id",
        name: "appointment",
        component: AppointmentView,
        meta: { title: "Thông tin đặt lịch" },
      },
      {
        path: "/booking/unavailable",
        name: "unavailable",
        component: UnavailableView,
        meta: { title: "Trang không khả dụng" },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0, left: 0 };
    }
  },
});

export default router;
